import {
  images,
  scrolling,
} from 'assets/utilities';

import { supportContent } from 'assets/components';

import './support.scss';

const onSelect = function onSupportSelect(ev) {
  const target = ev.currentTarget.value;
  window.location.hash = target;
};

const onHashChange = function onSupportHashChange() {
  const { hash } = window.location;

  [].forEach.call(
    document.querySelectorAll('.js-supportNavLinks a'),
    (el) => {
      el
        .classList[hash === el.getAttribute('href') ? 'add' : 'remove']('is-current');
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-supportNavLinks option'),
    (el) => {
      el.selected = el.getAttribute('value') === hash; // eslint-disable-line no-param-reassign
    },
  );
};

const bind = function bindSupport(props = {}) {
  const { isUnbind } = props;
  const action = isUnbind ? 'removeEventListener' : 'addEventListener';

  [].forEach.call(
    document.querySelectorAll('.js-supportSelect'),
    el => el[action]('change', onSelect),
  );

  window[action]('hashchange', onHashChange);
};

const destroy = function destroySupport() {
  supportContent.destroy();
  bind({ isUnbind: true });
};

const init = function initSupport() {
  window.scrollTo(0, 0);
  supportContent.init();
  scrolling.rebuildCache();
  images.init();
  bind();
  onHashChange();
};

export default {
  destroy,
  init,
};
